export default function FindingDocumentController(
  $q,
  $rootScope,
  $scope,
  alerts,
  amDataService,
  amSharedModelService,
  confirmDialog,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  editFindingDocumentDialog,
) {
  const vm = this;

  // Set Default Values
  vm.canExpand = vm.status !== 'No Finding Document Added';
  vm.isExpanded = false;
  vm.canDeleteItem = vm.canDelete;
  vm.canEditItem = vm.canEdit;

  // Attach Event Handlers
  vm.handleEditFindingDocument = _handleEditFindingDocument;
  vm.handleUnattachFindingDocument = _handleUnattachFindingDocument;

  vm.handleConfirmDelete = _handleConfirmDelete;
  vm.handleCancelDelete = _handleCancelDelete;

  function _handleEditFindingDocument($event) {
    ssDialogService.dialogs.auditTrail.editFindingDocumentDialog = ssDialogService.alert(
      editFindingDocumentDialog.getOptions($event, {
        findingId: vm.findingId,
        document: vm.findingDocument,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.auditTrail.editFindingDocumentDialog);
  }

  function _handleUnattachFindingDocument($event) {
    ssDialogService.dialogs.auditTrail.deleteFindingDocumentConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Remove Finding Document?',
        message: `Are you sure you want to remove document "${vm.findingDocument.description}"?`,
        handleYesClick: _handleConfirmDelete,
        handleNoClick: _handleCancelDelete,
      })
    );

    ssDialogService.show(ssDialogService.dialogs.auditTrail.deleteFindingDocumentConfirmDialog);
  }

  function _handleConfirmDelete() {
    loaderService.showViewLoader = true;
    return amDataService.detachFindingDocument(vm.findingDocument.findingDocumentId)
      .then(() => {
        alerts.success('The document has been removed successfully.');
        $rootScope.$broadcast('refreshAMFindingDocuments', { findingId: vm.findingDocument.findingId });
        _closeDeleteDialog();
      }).catch(() => {
        alerts.error('An error occurred while removing the document.');
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function _handleCancelDelete() {
    _closeDeleteDialog();
  }

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.auditTrail.deleteFindingDocumentConfirmDialog);
  }
}

FindingDocumentController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'amDataService',
  'amSharedModelService',
  'confirmDialog',
  'docDataService',
  'loaderService',
  'orgDataService',
  'ssDialogService',
  'editFindingDocumentDialog'
];
